import request from '../utils/request';
const querystring = require('querystring') ;
export const fetchData = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkActiveCode/selectPage.do',
        method: 'post',
        params: query
    }); 
    return list;
};
 
export const saveForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkActiveCode/insert.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};

export const changeForm = query => { 
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkActiveCode/update.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};
 
export const deleteById = query => {
    query.secret = localStorage.getItem('ms_secret');
    query.mid = localStorage.getItem('ms_mid');
    var list = request({
        url: 'haoka/hkActiveCode/delete.do',
        method: 'post',
        data: querystring.stringify(query), 
    }); 
    return list;
};
